import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import satelliteIcon from '../../../satelliteIcon';

const MultiOfficeRooms2 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="multiOfficeRooms" section="whyDifferent">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="multiOfficeRooms:whyDifferent" first noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default MultiOfficeRooms2;
